// Build-time injected manifest (see the `define` block in widget/vite.config.ts):
// shippedCatalogs is the per-locale JSON files actually present in
// widget/public/i18n at build time. Reading the shipped set from disk (instead
// of a hand-maintained list) means a resolution can never point at a catalog
// file that doesn't exist. The canonical supported set
// (pkg/domainsetting/locales.json) is enforced against this list in
// catalog.test.ts, not injected — the dev container mounts widget/ alone.
declare const __SM_I18N_SHIPPED__: string[];

// locale -> dist-relative catalog path, content-hashed in build
// (i18n/fr-a1b2c3d4.json) so the file can be served publicly cacheable, and
// unhashed in serve (i18n/fr.json) since vite serves public/ as-is. The hashed
// path is baked into min.js, which revalidates every load and so always points
// at the current catalog.
declare const __SM_I18N_URLS__: Record<string, string>;

export const shippedCatalogs: string[] = __SM_I18N_SHIPPED__;
export const catalogUrls: Record<string, string> = __SM_I18N_URLS__;
